import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import PopulateMonths from '../date-picker/date-picker/PopulateMonth';
import PopulateYears from '../date-picker/date-picker/PopulateYears';
import PopulateWeeks from './PopulateWeeks';
import CalenderHeader from './CalenderHeader';
import PopulateHeaders from './PopulateHeaders';
import { SELECT_VIEW } from './constants';
import { CalenderProps } from './types';

dayjs.extend(isBetween);

const Calender = ({
  showMonth,
  date,
  startDate,
  endDate,
  minDate,
  maxDate,
  dayHeaders = true,
  events = [],
  onClickPrevious,
  onClickNext,
  onClickMonth,
  onClickYear,
  eventCard,
  loading,
}: CalenderProps) => {
  const [activeSelectView, setActiveSelectView] = useState(SELECT_VIEW.DATE);
  const [activeId, setActiveId] = useState<number | string>();

  const [displayDate, setDisplayedDate] = useState(
    dayjs(showMonth || date || startDate),
  );

  const selected = (dates: Dayjs) => {
    return (
      (startDate &&
        endDate &&
        dates.isBetween(startDate, endDate, null, '[]')) ||
      (startDate && dates.isSame(startDate, 'day')) ||
      (date && dates.isSame(date, 'day'))
    );
  };

  const disabled = (dates: Dayjs) => {
    return (
      (minDate && dates.isBefore(minDate, 'day')) ||
      (maxDate && dates.isAfter(maxDate, 'day'))
    );
  };

  const onSelectMonth = (month: number) => {
    const data = dayjs(displayDate).set('month', month);
    setDisplayedDate(data);
  };

  const onSelectYear = (year: number) => {
    const data = dayjs(displayDate).set('year', year);
    setDisplayedDate(data);
  };

  useEffect(() => {
    if (showMonth || dayjs || startDate) {
      setDisplayedDate(dayjs(showMonth || date || startDate));
    }
  }, [showMonth, date, startDate]);

  return (
    <div className="bg-white rounded-4 w-100 position-relative">
      <CalenderHeader
        displayDate={displayDate}
        setDisplayedDate={setDisplayedDate}
        setActiveSelectView={setActiveSelectView}
        onClickNext={onClickNext}
        onClickPrevious={onClickPrevious}
      />

      <div className="p-6 py-10 w-100">
        {activeSelectView === SELECT_VIEW.DATE ? (
          <>
            {dayHeaders && (
              <div className="d-grid grid-cols-7">
                <PopulateHeaders displayDate={displayDate} />
              </div>
            )}
            <PopulateWeeks
              displayDate={displayDate}
              selected={selected}
              disabled={disabled}
              setActiveId={setActiveId}
              activeId={activeId}
              events={events}
              eventCard={eventCard}
              loading={loading}
            />
          </>
        ) : null}

        {activeSelectView === SELECT_VIEW.MONTH ? (
          <PopulateMonths
            onSelectMonth={onSelectMonth}
            setActiveSelectView={setActiveSelectView}
            displayDate={displayDate}
            onClickMonth={onClickMonth}
          />
        ) : null}

        {activeSelectView === SELECT_VIEW.YEAR ? (
          <PopulateYears
            onSelectYear={onSelectYear}
            setActiveSelectView={setActiveSelectView}
            displayDate={displayDate}
            onClickYear={onClickYear}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Calender;
